// @ts-nocheck
import React from "react";
import useAuth from '../../hooks/useAuth';
import { useTranslation } from "react-i18next";
import { Divider, List, Typography, Card, Flex, Carousel, ConfigProvider, Image } from 'antd';
import StoreList from "../../components/StoreList";
import GalleryVideoImg from "../../components/GalleryVideoImg";
import { Translate } from "../../services/translate";
import '../../styles/terms.css';

const TLSSorteios = () => {

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth, habRoles } = useAuth();

	const hab_func = habRoles([]);

	const gallery_list = [
		{
			"link": "/img/apps/sorteios_01.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/sorteios_02.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/sorteios_03.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/sorteios_04.jpeg",
			"video": false
		}
	];

	return (
		<div>
			<h2 className="title is-1">TLS Sorteios</h2>
			<br />
			<hr />
			<br />
			<StoreList
				//chrome_store={"https://chromewebstore.google.com/detail/ggogoinhjigamdpkogcjgkmlgcknlflb/preview?hl=pt-BR&authuser=1&pli=1"} 
				google_play={"https://play.google.com/store/apps/details?id=com.tlsengenharia.sorteios"}
				apple_store={"https://apps.apple.com/br/app/tls-sorteios/id6759976447"}
				microsoft_store={""}
				download={""}
				hab_download={hab_func}
				user={auth?.user}
			/>
			<br />
			<div style={{ width: "100%" }}>
				<div style={{ maxWidth: 903, margin: "auto" }}>
					<GalleryVideoImg gallery_list={gallery_list} />
				</div>
			</div>
			<br />
			<br />
			<Flex wrap gap="middle" justify="center" align="center">
				<List
					style={{ maxWidth: 1200 }}
					size="large"
					header={<h2 className="title is-1">{t('visao_geral')}</h2>}
					bordered
					dataSource={[<></>]}
					renderItem={(item: any) => <List.Item>{
						language == "pt-BR" ?
							(
								<>
									<div className='term_just'>
										Torne seus sorteios mais rápidos e organizados com o <strong>TLS Sorteios</strong>!<br />
										Ideal para quem precisa realizar sorteios de pessoas a partir de uma lista de nomes, o aplicativo permite importar listas, definir a quantidade de sorteados e manter um histórico completo de todos os sorteios realizados.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Importação de Listas:</strong> Carregue listas de nomes de forma prática e rápida.</li>
											<li><strong>Definição de Sorteados:</strong> Escolha facilmente a quantidade de pessoas a serem sorteadas.</li>
											<li><strong>Histórico de Sorteios:</strong> Consulte sorteios anteriores a qualquer momento.</li>
											<li><strong>Interface Simples:</strong> Uso intuitivo, sem necessidade de cadastro ou configurações complexas.</li>
										</ul>
										<br />
										Simplifique seus sorteios com o TLS Sorteios. Instale agora e tenha praticidade, transparência e agilidade em um só aplicativo!
									</div>
								</>
							)
							:
							language == "es" ?
								(
									<div className='term_just'>
										¡Haz tus sorteos más rápidos y organizados con <strong>TLS Sorteios</strong>!<br />
										Ideal para quienes necesitan realizar sorteos de personas a partir de una lista de nombres. La aplicación permite importar listas, seleccionar la cantidad de ganadores y mantener un historial completo de los sorteos realizados.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Importación de Listas:</strong> Carga listas de nombres de forma rápida y sencilla.</li>
											<li><strong>Selección de Ganadores:</strong> Define fácilmente cuántas personas serán sorteadas.</li>
											<li><strong>Historial de Sorteos:</strong> Consulta sorteos anteriores cuando lo necesites.</li>
											<li><strong>Interfaz Intuitiva:</strong> Uso simple, sin necesidad de registro.</li>
										</ul>
										<br />
										Simplifica tus sorteos con TLS Sorteios. ¡Instálalo ahora y disfruta de rapidez y transparencia!
									</div>
								)
								:
								(
									<div className='term_just'>
										Make your raffles faster and more organized with <strong>TLS Sorteios</strong>!<br />
										Ideal for anyone who needs to draw people from a list of names. The app allows you to import lists, select the number of winners, and keep a complete history of all raffles performed.
										<br />
										<br />
										<h3>Features:</h3><br />
										<ul>
											<li><strong>List Import:</strong> Easily upload name lists.</li>
											<li><strong>Winner Selection:</strong> Choose how many people will be drawn.</li>
											<li><strong>Draw History:</strong> Access previous draws at any time.</li>
											<li><strong>Simple Interface:</strong> Intuitive use, no registration required.</li>
										</ul>
										<br />
										Simplify your raffles with TLS Sorteios. Install now and enjoy speed, transparency, and convenience!
									</div>
								)
					}
					</List.Item>}
				/>
			</Flex>
		</div>
	);
}


export default TLSSorteios;